export default defineNuxtPlugin(async (nuxtApp) => {
    // const head = nuxtApp.vueApp._context.provides.usehead
    // // @ts-ignore
    // const site = await nuxtApp.vueApp.$nuxt.$api.get('public/general')
    // head.push({
    //     link: [{ rel: 'icon', type: 'image/png', href:  site.data.fav}]
    // })
});